exports.DOMImplementation = global.DOMImplementation;
exports.XMLSerializer = global.XMLSerializer;
exports.DOMParser = global.DOMParser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/roslib/src/util/shim/xmldom.js
// module id = 377
// module chunks = 0